import { Component } from "vue";
import TableColumnTypePopover from "../components/TableColumnTypePopover.vue";
import { TableHelpContentType } from "../models/TableHelpContentType";
import TableFooterTypePopover from "../components/TableFooterTypePopover.vue";
import { HelpContentFactory } from "@/shared/help/services/HelpContentFactory";



export class TableHelpContentFactory extends HelpContentFactory<TableHelpContentType> {

    public cdnContentPath: string = "tables";

    public async tryGetStaticHelpContentByType(type: TableHelpContentType | string): Promise<Component | null> {
        switch (type) {
            case TableHelpContentType.TableColumnType:
                return TableColumnTypePopover;
            case TableHelpContentType.TableFooterType:
                return TableFooterTypePopover;
            default:
                return null;
        }
    }

}